import { XPlusYDiscount } from '@/js/App/XPlusYDiscount'
import { Control } from '@peckadesign/pd-naja/dist/types'

class XPlusYDiscountControl implements Control {
	public initialize(context: Element | Document) {
		const xPlusYDiscounts = context.querySelectorAll<HTMLElement>('.js-x-plus-y-discount')

		xPlusYDiscounts.forEach((xPlusYDiscount) => new XPlusYDiscount(xPlusYDiscount))
	}
}

export default new XPlusYDiscountControl()
